import { render, staticRenderFns } from "./ChooseButtonWrapper.vue?vue&type=template&id=91888768&"
import script from "./ChooseButtonWrapper.vue?vue&type=script&lang=js&"
export * from "./ChooseButtonWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports